<h1 mat-dialog-title>Edit Change Set on {{ this.data.effectiveDate | date: 'medium' }}</h1>
<div>
    <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
        <div mat-dialog-content>
            <mat-form-field id="effective-date">
                <input
                    formControlName="effectiveDate"
                    matInput
                    [min]="minDate"
                    [matDatepicker]="picker"
                    placeholder="Effective Date"
                    readonly="true"
                    (dateChange)="onDateChanged($event)"
                >
                <mat-datepicker-toggle
                    data-testid="datepicker_toggle"
                    [disabled]="!changeSet"
                    [for]="picker"
                    matSuffix
                ></mat-datepicker-toggle>
                <mat-datepicker #picker [dateClass]="highlightDate"></mat-datepicker>
                <mat-error *ngIf="form.controls['effectiveDate'].errors?.changeSetExists">
                    Please select another date with no existing change set.
                </mat-error>
                <mat-hint *ngIf="dateChanged">
                    This will move <strong>ALL CHANGES</strong> for <strong>ALL SUBMENUS</strong> to the newly selected effective date.
                </mat-hint>
                <mat-hint *ngIf="dateChangedToToday">
                    IMPORTANT: This change set will now be applied to the current menu immediately.
                </mat-hint>
            </mat-form-field>
        </div>
        <div class="mt-2 mb-0" mat-dialog-actions *ngIf="!isReadOnlyScope">
            <button
                [attr.data-testid]="'cancel_button'"
                class="button-color"
                mat-raised-button
                matTooltip="Cancel"
                type="button"
                (click)="cancelChangeSet()"
            >
                Cancel
            </button>
            <button
                [attr.data-testid]="'change_set_button'"
                class="button-color"
                [disabled]="form.pristine || form.invalid || (isReadOnly$ | async) || disableSubmit"
                mat-raised-button
                matTooltip="Save"
                type="submit"
            >
                 Reschedule
            </button>
            <div class="pl-2 pt-2" *ngIf="dateChanged || dateChangedToToday">
                <mat-error>
                    <mat-icon class="icon">update</mat-icon>
                    <mat-icon class="icon" *ngIf="dateChangedToToday">priority_high</mat-icon>
                </mat-error>
            </div>
        </div>
    </form>
</div>
